
import { useToast } from "@chakra-ui/react";

const useCustomToast = () => {
    const toast = useToast();

    const showSuccessToast = (description = "Action completed successfully!") => {
        toast({
            title: "Success!",
            description,
            status: "success",
            duration: 3000,
            isClosable: true,
            position: "bottom-left"
        });
    };

    const showErrorToast = (description = "Something went wrong.") => {
        toast({
            title: "Error!",
            description,
            status: "error",
            duration: 3000,
            isClosable: true,
            position: "bottom-left"
        });
    };

    return { showSuccessToast, showErrorToast };
};

export default useCustomToast;
